import React, { useState } from 'react';
import { Users, Plus, Minus, Info } from 'lucide-react';
import Button from '../../../../components/common/Button';
import Card from '../../../../components/common/Card';
import Alert from '../../../../components/common/Alert';

export default function SeatAllocation({ onComplete, initialData = {}, planDetails, onBack }) {
  const [seats, setSeats] = useState(initialData.count || 1);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onComplete({ count: seats });
  };

  const incrementSeats = () => {
    setSeats(prev => prev + 1);
  };

  const decrementSeats = () => {
    if (seats > 1) {
      setSeats(prev => prev - 1);
    }
  };

  // Calculate the total price based on seat count and billing period
  const calculateTotalPrice = () => {
    if (!planDetails || !planDetails.planId) return 0;
    
    // This is a placeholder - you would need to get the actual plan price from your API
    const basePricePerSeat = planDetails.billingPeriod === 'yearly' ? 120 : 12; // $12/mo or $120/yr
    return basePricePerSeat * seats;
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <Users className="h-12 w-12 text-primary mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-navy">How many seats do you need?</h2>
        <p className="text-navy/70 mt-2">
          Each seat allows one user to access Stickr's features
        </p>
      </div>

      <Card className="p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="font-medium text-navy">Number of Seats</h3>
            <p className="text-sm text-navy/70">
              You can add more seats later if needed
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <button
              type="button"
              onClick={decrementSeats}
              disabled={seats <= 1}
              className={`rounded-full p-2 ${
                seats <= 1 
                  ? 'bg-gray-100 text-gray-400' 
                  : 'bg-light-purple/10 text-primary hover:bg-light-purple/20'
              }`}
            >
              <Minus className="h-5 w-5" />
            </button>
            <span className="text-2xl font-semibold text-navy min-w-[40px] text-center">
              {seats}
            </span>
            <button
              type="button"
              onClick={incrementSeats}
              className="rounded-full p-2 bg-light-purple/10 text-primary hover:bg-light-purple/20"
            >
              <Plus className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-navy">Plan: {planDetails.planName}</span>
            <span className="text-navy">${calculateTotalPrice().toFixed(2)}/{planDetails.billingPeriod === 'monthly' ? 'mo' : 'yr'}</span>
          </div>
          <div className="flex justify-between items-center text-sm text-navy/70">
            <span>
              {seats} {seats === 1 ? 'seat' : 'seats'} × ${(calculateTotalPrice() / seats).toFixed(2)}/{planDetails.billingPeriod === 'monthly' ? 'mo' : 'yr'}
            </span>
          </div>
        </div>
      </Card>

      <Alert type="info">
        <Info className="h-4 w-4 mr-2" />
        The first seat is automatically assigned to you as the admin.
      </Alert>

      <div className="flex justify-between mt-8">
        <Button variant="outline" onClick={onBack}>
          Back
        </Button>
        <Button onClick={handleSubmit}>
          Continue to Payment
        </Button>
      </div>
    </div>
  );
} 